var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material-attention"},[(_vm.attention)?_c('div',{staticClass:"title"},[_vm._v("资料要求:")]):_vm._e(),_vm._v(" "),(_vm.attention)?_c('ul',{staticClass:"items"},_vm._l((_vm.attentionArr),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"content",domProps:{"textContent":_vm._s(item)}})])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562cc8c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/attention.vue
// module id = null
// module chunks = 